

const UrlConfigs = {
    MAP_STYLE_URL : 'mapbox://styles/mapbox/streets-v11',
    MAPBOX_ACCESS_TOKEN : 'pk.eyJ1Ijoic3JpbmF0aHJhamEiLCJhIjoiY2xoNXR2NGp2MGJzMDNlczg5ZDA5ZTNwdSJ9.VPL2vn4eXArjXHpPz9RYQg',
    API_URL: 'https://api.pixvisonz.com/v1/'
}

export default UrlConfigs